import { SolutionPage } from './SolutionPage'
import { solutionsData } from '@/data/solutions'

export default function Marketing() {
  return <SolutionPage solution={solutionsData.marketing!} />
}
